import React from 'react';
import { Box, ShimmerBox } from '@common-fe/common-fe';

export const TransactionLinkedLmnListLoader = (
  <Box data-testId="transaction-linked-lmn-list-loader">
    <ShimmerBox margin={{ bottom: 'spacing12' }} height="128px" width="100%" />
    <ShimmerBox margin={{ bottom: 'spacing12' }} height="128px" width="100%" />
    <ShimmerBox height="128px" width="100%" />
  </Box>
);
